<!--
 * @Author: wjw
 * @Github: https://github.com/wangjiawei2019
 * @Date: 2019-06-20 20:38:47
 * @LastEditors: linfangxing 2948276710@qq.com
 * @LastEditTime: 2023-12-20 14:27:01
 -->
<template>
  <div class="organ-page">
    <Tab :tabList="tabList" @toggleTab="toggleTab"></Tab>
    <article class="img-box" v-if="this.aim == 0">
      <div></div>
    </article>
    <ul class="organ-footer" v-if="this.aim == 1">
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
    </ul>
    <!-- 直属单位 -->
    <ul class="drus" v-if="this.aim == 3">
      <li></li>
      <li></li>
      <li></li>
    </ul>
    <!-- 分支机构 -->
    <footer v-if="this.aim == 2">
      <ul class="footer">
        <li
          v-for="item in searchRes.list"
          :key="item.id"
          @click="handleGoContent(item.id)"
        >
          <span class="item-title">{{ item.title }}</span>
          <span class="item-createtime">{{ item.createtime }}</span>
        </li>
      </ul>
      <div class="search-footer">
        <el-pagination
          background
          layout="pager, next"
          :current-page="searchRes.start_page"
          :total="searchRes.count"
          @current-change="currentPageClick"
        ></el-pagination>
      </div>
    </footer>
  </div>
</template>

<script>
import Tab from "@/components/tab";
import Api from "@/api/commonApi";
import store from "@/store";

export default {
  components: {
    Tab,
  },
  data() {
    return {
      aim: 0,
      searchRes: {
        count: null,
        list: [],
        start_page: null,
        total_page: null,
      },
      tabList: [
        { id: 0, name: "组织机构图" },
        { id: 1, name: "内设机构" },
        { id: 2, name: "分支机构" },
        { id: 3, name: "直属单位" },
      ],
    };
  },
  methods: {
    toggleTab(i) {
      this.aim = i;
      if (i == 2) {
        // 获取分支机构文章列表
        Api.getRightList(25, 1)
          .then((res) => {
            const { count, list, start_page, total_page } = res.data;
            this.searchRes.count = count;
            this.searchRes.list = list;
            this.searchRes.start_page = parseInt(start_page);
            this.searchRes.total_page = total_page;
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    showlist(type, start_page) {
      // 请求右边课程列表
      Api.getRightList(type, start_page)
        .then((res) => {
          const { count, list, start_page, total_page } = res.data;
          this.searchRes.count = count;
          this.searchRes.list = list;
          this.searchRes.start_page = parseInt(start_page);
          this.searchRes.total_page = total_page;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 点击页数跳转
    currentPageClick(page) {
      // 存储当前页数
      store.commit("News/currentPage", page);
      this.backTop();
      this.showlist(25, page);
    },
    // 点击文章列表进入文章
    handleGoContent(id) {
      let { href } = this.$router.resolve({
        path: `/info/2/${id}`,
      });
      window.open(href, "_blank");
    },
    // 点击页数 返回顶部
    backTop() {
      document.documentElement.scrollTop = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("minireset.css");
@mixin font-style($family, $size, $color, $weight) {
  font-family: $family;
  font-size: $size;
  color: $color;
  font-weight: $weight;
}
%ulst {
  margin: 0;
  padding: 0;
  list-style: none;
}
@mixin displayflex($row, $column, $direction, $wrap) {
  display: flex;
  @if $direction == column {
    flex-direction: column;
  } @else {
    flex-direction: row;
  }
  @if $wrap == wrap {
    flex-wrap: wrap;
  } @else {
    flex-wrap: nowrap;
  }
  justify-content: $row;
  align-items: $column;
}
.organ-page {
  box-sizing: border-box;
  padding: 30px 40px 40px 40px;
  .img-box {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 668px;
    & > div {
      width: 732px;
      height: 550px;
      background-image: url("../../assets/about/zuzhijigou.png");
      background-size: 100% 100%;
    }
  }
  .organ-footer {
    display: flex;
    height: 100%;
    flex-direction: column;
    li {
      margin-top: 40px;
      width: 100%;
    }
    li:nth-child(1) {
      height: 562px;
      background-image: url("../../assets/about/jigou1.jpg");
      background-size: 100% 100%;
    }
    li:nth-child(2) {
      height: 402px;
      background-image: url("../../assets/about/jigou2.jpg");
      background-size: 100% 100%;
    }

    li:nth-child(3) {
      height: 370px;
      background-image: url("../../assets/about/jigou4.jpg");
      background-size: 100% 100%;
    }
    li:nth-child(4) {
      height: 301px;
      background-image: url("../../assets/about/jigou5.png");
      background-size: 100% 100%;
    }
    li:nth-child(5) {
      height: 434px;
      background-image: url("../../assets/about/jigou6.jpg");
      background-size: 100% 100%;
    }
    li:nth-child(6) {
      height: 398px;
      background-image: url("../../assets/about/jigou7.jpg");
      background-size: 100% 100%;
    }
    li:nth-child(7) {
      height: 428px;
      background-image: url("../../assets/about/jigou3.jpg");
      background-size: 100% 100%;
    }
    li:nth-child(8) {
      height: 398px;
      background-image: url("../../assets/about/jigou8.jpg");
      background-size: 100% 100%;
    }
  }
  .drus {
    display: flex;
    height: 100%;
    flex-direction: column;
    li {
      margin-top: 40px;
      width: 100%;
      background-size: 100% 100%;
    }
    li:nth-child(1) {
      height: 524px;
      background-image: url("../../assets/about/drus1.jpg");
    }
    li:nth-child(2) {
      height: 433px;
      background-image: url("../../assets/about/drus2.jpg");
    }
    li:nth-child(3) {
      height: 492px;
      background-image: url("../../assets/about/drus3.jpg");
    }
  }
  footer {
    .footer {
      @extend %ulst;
      width: 100%;
      & > li {
        width: 100%;
        height: 53px;
        @include displayflex(space-between, center, row, nowrap);
        border-bottom: 1px dashed #dbdbdb;
        cursor: pointer !important;
        .item-title {
          flex: 1;
          @include font-style("PingFangSC-Regular", 17px, #3a3a3a, 400);
          &:hover {
            cursor: pointer !important;
            color: #c52e0f !important;
          }
        }
        .item-createtime {
          @include font-style("PingFangSC-Regular", 14px, #7a7a7a, 400);
        }
      }
    }
    .search-footer {
      margin-top: 49px;
      @include displayflex(center, center, row, nowrap);
    }
  }
}
</style>
<style lang="scss">
@mixin font-style($family, $size, $color, $weight) {
  font-family: $family;
  font-size: $size;
  color: $color;
  font-weight: $weight;
}
.search-footer {
  @mixin font-style($family, $size, $color, $weight) {
    font-family: $family;
    font-size: $size;
    color: $color;
    font-weight: $weight;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  margin-top: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/about/Organization.vue